import type { PaymentMethod } from "@jti/fe-common";

const sortMethodsByEnabled = (a: PaymentMethod, b: PaymentMethod) => {
  return a.enabled === b.enabled ? 0 : a.enabled ? -1 : 1;
};

export default sortMethodsByEnabled;
